import React, { useEffect } from 'react';
import './HeroSection.css';
import { Link } from 'react-router-dom';

// HeroSection: Smarter studying starts here
export default function HeroSection(){
  // One-time shimmer for SIGN UP (hero ghost CTA).
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const el = document.querySelector('.m-hero-ctas .btn-ghost.gradient-border');
    if (el) {
      el.classList.add('shimmer');
      try { window.dispatchEvent(new CustomEvent('dh:signup-shimmer')); } catch (e) {}
      window.setTimeout(() => el.classList.remove('shimmer'), 3000);
    }
  }, []);

  // Activate fade-in for hero heading/subheadline once mounted
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      document.querySelectorAll('.fade-up-hero, .fade-up-hero-delayed').forEach(n => n.classList.add('is-visible'));
      return;
    }
    requestAnimationFrame(() => {
      document.querySelectorAll('.fade-up-hero').forEach(n => n.classList.add('fade-ready'));
      setTimeout(() => {
        document.querySelectorAll('.fade-up-hero-delayed').forEach(n => n.classList.add('fade-ready'));
      }, 40);
    });
  }, []);

  return (
    <section id="hero" className="snap-section m-hero m-wrapper" aria-labelledby="m-hero-title" data-section="hero">
      {/* Scout with radial glow */}
      <div className="hero-scout-container fade-up-1">
        <div className="hero-scout-glow" aria-hidden="true"></div>
        <img 
          src="/scout_images/Scout_Thumbsup.png" 
          alt="Scout the Beagle in graduation cap" 
          className="hero-scout-image" 
        />
      </div>

      {/* Hero content card */}
      <div className="hero-content-card fade-up-2">
        <h1 id="m-hero-title" className="hero-headline">
          Stop juggling school like it's your only job.
        </h1>

        <p className="hero-subheadline">
          School is one of many things on your plate. DocuHounds organizes your classes, deadlines, and study tools so nothing slips.
        </p>

        <ul className="hero-bullets">
          <li>
            <span className="hero-bullet-check" aria-hidden="true">✓</span>
            See every class, deadline, and assignment in one place
          </li>
          <li>
            <span className="hero-bullet-check" aria-hidden="true">✓</span>
            Turn your materials into flashcards, quizzes, and study tools instantly
          </li>
          <li>
            <span className="hero-bullet-check" aria-hidden="true">✓</span>
            Stay on track without juggling tabs, planners, and half-used apps
          </li>
        </ul>

        <div className="hero-cta-group">
          <Link 
            to="/m/register" 
            className="hero-cta-primary" 
            data-cta="primary"
          >
            START FREE
          </Link>
          <a 
            href="#how-it-works" 
            className="hero-cta-secondary" 
            data-cta="secondary"
          >
            SEE HOW IT WORKS
          </a>
          <p className="hero-cta-microcopy">
            One system for school. Built for students balancing real life.
          </p>
        </div>
      </div>

      <a href="#features" className="scroll-chip fade-up-4" aria-label="Scroll to explore">
        <span className="scroll-label">Scroll to explore</span>
        <svg className="scroll-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
      </a>
    </section>
  );
}
